<template>
  <div class="underinfo">
    <!-- 顶部搜索 -->
    <div class="dyh-line-group">
      <!-- <div class="dyh-line-group-label">所有店铺</div> -->
      <div class="underinfo-top-l-f" style="">
        <span @click="classChange(item)" v-for="item in classList" :key="item" class="underinfo-top-l-f-span" :class="ckeyWords.includes(item) == true
          ? 'underinfo-top-l-f-clicked'
          : 'underinfo-top-l-f-span'
          ">
          {{ item }}
        </span>
      </div>
      <el-input size="mini" placeholder="输入店铺名、店铺id搜索" v-model="search_value" class="input-with-select">
      </el-input>
      <el-button size="mini" slot="append" type = "primary" @click="getShopList()"> 重新获取</el-button>
      <el-button size="mini" slot="append" type = "primary" @click="upgradeAll()"> 全部升级</el-button>
    </div>
    <!-- 底部表格 -->
    <div class="underinfo-btm dyh-body-group">
      <ve-table id="underinfo" v-if="ui_show" :scroll-width="0" :border-y="true" :max-height="scroll_height"
        :columns="underinfoColumn" :table-data="underinfo_list" row-key-field-name="rowKey"
        :cell-style-option="cellStyleOption" />
    </div>
    <!-- createCard
      ref="createCardRef"
      v-show="true"
      :title="'威富通信息'"
      @closeCreateCard="closeCreateCard"
    >
      <template v-slot:title>
        威富通信息
      </template>
<template v-slot:cardForm>
        <swift :who="'service'" ref="swiftRef"></swift>
      </template>
<template v-slot:btn_name>
        <div class="wty-footer">
          <el-button type="primary" @click="modifySwift">
            修改
          </el-button>
          <el-button type="success" @click="saveSwiftConfigure">
            保存
          </el-button>
        </div>
      </template>
</createCard> -->
  </div>
</template>
<script>
import { getOnLineMerchant, getOfflinestoresList } from "@/api/service.js";
import { serviceOfflinestoresUpgrade } from "@/api/v2/service.js";
import { cellStyleOption } from "@/js/sheettablecolumn.js";
/**
 * 先隐藏现在不能用
 */
/* import createCard from "@/components/createCard";
import swift from "@/components/swift"; */
export default {
  name: "underinfo",
  // components: { swift, createCard },
  data() {
    return {
      ui_show: true, //表格是否显示
      //单元格样式
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
        ...cellStyleOption
      },
      //线下店铺信息表格的列
      underinfoColumn: [
        {
          field: "index",
          key: "a",
          title: "行号",
          width: 60,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return row.rowKey + 1;
          }
        },

        // 表头信息
        {
          field: "merchant_id",
          key: "merchant_id",
          title: "店铺id",
          align: "center",
          width: 150,
          fixed: "left"
        },
        {
          field: "merchant_name",
          key: "merchant_name",
          title: "店铺名称",
          align: "center",
          width: 250,
          fixed: "left",
          ellipsis: {
            showTitle: true
          }
        },
        {
          field: "ip",
          key: "ip",
          title: "ip地址",
          align: "center",
          width: 150
        },
        {
          field: "port",
          key: "port",
          title: "端口号",
          align: "center",
          width: 100
        },
        {
          field: "version",
          key: "version",
          title: "服务器版本",
          align: "center",
          width: 100
        },
        {
          field: "host_name",
          key: "host_name",
          title: "主机名",
          align: "center",
          width: 150
        },
        {
          field: "oray_code",
          key: "oray_code",
          title: "向日葵识别码",
          align: "center",
          width: 100
        },
        {
          field: "oray_password",
          key: "oray_password",
          title: "向日葵密码",
          align: "center",
          width: 100
        },
        {
          field: "todesk_code",
          key: "todesk_code",
          title: "todesk识别码",
          align: "center",
          width: 100
        },
        {
          field: "todesk_password",
          key: "todesk_password",
          title: "todesk密码",
          align: "center",
          width: 100
        },
        {
          field: "",
          key: "e",
          title: "管理",
          width: 200,
          center: "left",
          fixed: "right",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span class="button-fa">
                <button
                  class="underinfo-button-primary"
                  on-click={() => this.editRow(row, rowIndex)}
                >
                  升级服务
                </button>
                &nbsp;
                {/* <button
                  class="underinfo-button-err"
                  on-click={() => this.swiftInfo(row, rowIndex)}
                >
                  配置威富通信息
                </button> */}
              </span>
            );
          }
        }
      ],
      //
      classList: ["所有", "在线", "离线"],
      ckeyWords: ["在线"],
      search_value: "", //input搜索值
      underinfo_list: [], //显示店铺
      all_underinfo_list: [], //所有店铺
      scroll_height: "" //表格高度
    };
  },
  watch: {
    innerWH: {
      handler(newinner, oldinner) {
        if (newinner.innerHeight < 700) {
          this.scroll_height = newinner.innerHeight - 180;
        } else {
          this.scroll_height = newinner.innerHeight - 210;
        }
      },
      deep: true,
      immediate: true
    },
    search_value: {
      handler(newvr, oldv) {
        this.search();
      }
    }
  },
  computed: {
    innerWH() {
      return this.$store.state.resolution.innerWH;
    }
  },
  async mounted() {
    this.loadingInstance = this.$veLoading({
      target: "#in-sheet",
      // 等同于
      // target:"#loading-container"
      overlayBackgroundColor: "rgba(255,255,255,.5)",
      name: "grid"
    });
    this.getShopList();
  },
  methods: {
    /**
     * 调用swift组件的保新建
     */
    saveSwiftConfigure() {
      this.$refs.swiftRef.saveSwiftConfigure();
    },
    /**
     * 调用swift组件的修改
     */
    modifySwift() {
      this.$refs.swiftRef.modifySwift();
    },
    closeCreateCard(e) {
      console.log("closeCreateCard", e);
    },
    swiftInfo() {
      this.$refs.createCardRef.openBox();
    },
    async upgrade(list) {
      const res = await serviceOfflinestoresUpgrade(list);
      if (this.testR(res)) {
        const reslist = res.data.resp_data;
        let isfail = false;
        for (let i = 0; i < reslist.length; i++) {
          for (let j = 0; j < this.all_underinfo_list.length; j++) {
            if (
              reslist[i].state === "FAIL" &&
              reslist[i].merchant_id === this.all_underinfo_list[j].merchant_id
            ) {
              this.all_underinfo_list[j].class_state = "9";
              isfail = true;
            }
          }
        }
        if (isfail) {
          if (this.classList.indexOf("升级失败") < 0) {
            this.classList.push("升级失败");
          }
          this.classChange("升级失败");
        }
      }
    },
    editRow(row, rowIndex) {
      if (row.class_state === "5") {
        this.warnMessage("店铺不在线，无法自动升级");
        return;
      } else if (row.class_state === "9") {
        for (let i = 0; i < this.all_underinfo_list.length; i++) {
          if (row.merchant_id === this.all_underinfo_list[i].merchant_id) {
            this.all_underinfo_list[i].class_state = "0";
          }
        }
      }
      let list = [];
      list.push({
        merchant_id: row.merchant_id
      });
      /* if (row.class_state == "9") {
        return;
      } */

      this.upgrade(list);
      this.testNineLength();
    },
    upgradeAll() {
      let list = [];
      for (let i = 0; i < this.all_underinfo_list.length; i++) {
        if (
          this.all_underinfo_list[i].class_state === "0" ||
          this.all_underinfo_list[i].class_state === "9"
        ) {
          list.push({
            merchant_id: this.all_underinfo_list[i].merchant_id
          });
        }
        if (this.all_underinfo_list[i].class_state === "9") {
          this.all_underinfo_list[i].class_state = "0";
        }
      }
      this.upgrade(list);
      this.testNineLength();
    },
    testNineLength() {
      var key = true;
      for (let i = 0; i < this.all_underinfo_list.length; i++) {
        if (this.all_underinfo_list[i].class_state === "9") {
          key = false;
        }
      }
      if (key) {
        this.classList = ["所有", "在线", "离线"];
        this.classChange("在线");
      }
    },
    //搜索店铺
    search() {
      if (this.search_value === "") {
        this.classChange(this.ckeyWords[0]);
        return;
      }
      let list = [];
      for (let i = 0; i < this.underinfo_list.length; i++) {
        try {
          if (
            this.underinfo_list[i].merchant_name.indexOf(this.search_value) >
            -1 ||
            this.underinfo_list[i].merchant_id.indexOf(this.search_value) > -1
          ) {
            list.push(this.underinfo_list[i]);
          }
        } catch (e) {
          console.log(JSON.stringify(e));
        }
      }
      this.underinfo_list = [];

      this.underinfo_list = this.setRowKey(list);
      // console.log("0----------------------------",this.underinfo_list);
    },
    /**
     * @param {"所有"|"在线"|"离线"|"升级失败"} keywords
     */
    classChange(keywords) {
      this.ckeyWords = [];
      this.ckeyWords.push(keywords);
      this.underinfo_list = [];
      let key = "";
      if (keywords === "所有") {
        this.underinfo_list = this.setRowKey(this.all_underinfo_list);
        return;
      }
      switch (keywords) {
        case "在线":
          key = "0";
          break;
        case "离线":
          key = "5";
          break;
        case "升级失败":
          key = "9";
          break;
      }
      try {
        for (let i = 0; i < this.all_underinfo_list.length; i++) {
          if (this.all_underinfo_list[i].class_state === key) {
            this.underinfo_list.push(this.all_underinfo_list[i]);
          }
        }
        this.underinfo_list = this.setRowKey(this.underinfo_list);
      } catch (e) {
        this.warnMessage(JSON.stringify(e));
        console.log(e);
      }
    },

    deleteRow() {
      console.log("this.deleteRow");
    },
    //设置rowkey
    setRowKey(list) {
      for (let i = 0; i < list.length; i++) {
        list[i].rowKey = i;
      }
      return list;
    },
    /**
     * 获取店铺列表
     */
    async getShopList() {
      this.underinfo_list = [];
      //接口获取所有注册过的店铺
      const ls = await getOfflinestoresList();
      for (let i = 0; i < ls.length; i++) {
        this.underinfo_list.push({
          rowKey: i,
          merchant_id: ls[i].merchant_id,
          merchant_name: ls[i].merchant_name,
          class_state: "5"
        });
      }

      //隐藏表格
      this.ui_show = false;
      setTimeout(async () => {
        //接口获取所有在线店铺
        const list = await getOnLineMerchant();
        for (let j = 0; j < this.underinfo_list.length; j++) {
          for (let i = 0; i < list.length; i++) {
            if (this.underinfo_list[j].merchant_id === list[i].merchant_id) {
              this.underinfo_list[j] = {
                ...this.underinfo_list[j],
                class_state: "0",
                ...(list[i] ? list[i] : "")
              };
            }
          }
        }
        //显示表格
        this.ui_show = true;
        this.all_underinfo_list = this.underinfo_list;
        this.classChange(this.ckeyWords[0]);
      }, 100);

      //
    }
  }
};
</script>

<style lang="less">
.table-header-cell-class {
  background: #409eff !important;
  color: #fff !important;
}

.underinfo-top {
  display: flex;
  justify-content: space-between;

  &-l-f {
    display: flex;
    align-items: center;
    width: calc(100% - 285px);
    height: 40px;
    scrollbar-width: none;
    padding: 0 10px 0 0;

    &-span {
      margin: 0 10px 0 0;
      color: #606266;
      cursor: pointer;
      user-select: none;
    }

    &-clicked {
      color: #409eff;
      font-weight: 700;
    }
  }
}

.underinfo {
  width: 100%;
  height: 100%;
}

.underinfo-btm {
  width: 100%;
  margin-top: 10px;
  user-select: text;
}

td {
  user-select: text;
}

#underinfo {
  user-select: text !important;
}

.button-fa {
  display: flex;
  justify-content: center;
  align-items: center;
}

.underinfo-button-primary {
  background-color: #409eff;
  color: #fff;
  // min-width: 60px;
  min-height: 30px;
  width: 80px;
  user-select: none;
}

.underinfo-button-err {
  background-color: #e6a23c !important;
  color: #fff;
  // min-width: 60px;
  min-height: 30px;
  width: 100px !important;
  font-size: 10px !important;
  user-select: none;
}
</style>
